'use client';

import React, { useState, useEffect } from 'react';
import { Box, LucideIcon, Text, useBreakpointValue } from '@skin-seoul/design-system';
import { formatCurrency, useProductService, useRegionCurrency, useUser } from '@skin-seoul/service';
import SectionContainer from '../../components/SectionContainer';
import { useParams } from 'next/navigation';
const FreeShippingSection = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const {
    data: {
      shippingPolicy
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  const {
    isAuthenticated
  } = useUser();
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const showTopBorder = useBreakpointValue({
    base: true,
    tablet: false
  });
  return <SectionContainer headerTitle={`Standard delivery in ${shippingPolicy.minDeliveryDays} - ${shippingPolicy.maxDeliveryDays} business days`} sectionInnerProps={{
    gap: 3,
    width: '100%'
  }} showTopBorder={showTopBorder} data-sentry-element="SectionContainer" data-sentry-component="FreeShippingSection" data-sentry-source-file="FreeShippingSection.tsx">
      <Box borderRadius="4px" backgroundColor="neutral.50" padding={3} display="flex" gap={1} width="100%" alignItems="flex-start" data-sentry-element="Box" data-sentry-source-file="FreeShippingSection.tsx">
        <LucideIcon className="neutral.600" name="CircleAlert" boxSize={4} data-sentry-element="LucideIcon" data-sentry-source-file="FreeShippingSection.tsx" />
        <Text textStyle="label.medium" fontWeight="medium" color="neutral.600" data-sentry-element="Text" data-sentry-source-file="FreeShippingSection.tsx">
          Latest Korean beauty releases imported directly from Seoul — authentic, current, and fresh from the source.
          Due to year-end holiday period, delivery partners and customs offices may operate with reduced capacity.
          Please allow an additional 10-12 days for potential delays.
        </Text>
      </Box>
      <Box width="100%" height={{
      base: '74px',
      tablet: '92px'
    }} background="linear-gradient(90deg, #5645AF 0%, #000000 30%)" borderRadius="8px" position="relative" overflow="hidden" data-sentry-element="Box" data-sentry-source-file="FreeShippingSection.tsx">
        {/* Main Text */}
        <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" display="flex" alignItems="center" justifyContent="center" width="100%" flexDirection="column" gap={2} paddingX={4} data-sentry-element="Box" data-sentry-source-file="FreeShippingSection.tsx">
          {!isMounted ? null : !isAuthenticated ? <>
              <Text textStyle={{
            base: 'label.large',
            tablet: 'heading.h6'
          }} color="white" fontWeight="medium" letterSpacing={{
            tablet: '-0.4px'
          }} textAlign="center">
                Sign up to unlock
              </Text>
              <Text textStyle={{
            base: 'label.large',
            tablet: 'heading.h6'
          }} color="white" fontWeight="medium" letterSpacing={{
            tablet: '-0.4px'
          }} textAlign="center">
                <Text as="span" fontWeight="semibold">
                  Free Shipping
                </Text>{' '}
                and up to{' '}
                <Text as="span" fontWeight="semibold">
                  15% OFF!
                </Text>
              </Text>
            </> : <>
              <Text textStyle={{
            base: 'label.large',
            tablet: 'heading.h6'
          }} color="white" fontWeight="semibold" letterSpacing={{
            tablet: '-0.4px'
          }} textAlign="center">
                {`Spend ${formatCurrency(currency, shippingPolicy.freeShippingThreshold).replace(/\.\d{2}$/, '')} and get Free Shipping`}
              </Text>

              <Text textStyle={{
            base: 'label.small',
            tablet: 'label.medium'
          }} color="neutral.100" fontWeight="medium" textAlign="center">
                <Text as="span" fontWeight="semibold" color="neutral.50">
                  Register
                </Text>
                {' to Unlock Free Shipping for 1st Order'}
              </Text>
            </>}
        </Box>
      </Box>
    </SectionContainer>;
};
export default FreeShippingSection;